import React, { useCallback } from 'react'
import Datepicker from 'react-datepicker'
import classNames from 'classnames'
import { BsCalendar3 } from 'react-icons/bs'

import { FieldWrapper } from '..'

import { DateInputProps } from './types'
import 'react-datepicker/dist/react-datepicker.css'
import * as styles from './dateInput.module.scss'

const DateInput = ({
   description,
   insetDescription = false,
   error,
   disabled = false,
   id,
   label,
   maxDate,
   minDate,
   noMargin = false,
   onChange,
   placeholder,
   required,
   selectedDate,
   withWrappers = true,
   popperPlacement,
}: DateInputProps) => {
   const handleDatepickerChange = useCallback(
      (date: Date) => onChange(date),
      [onChange, selectedDate]
   )

   const classes = classNames(styles.datePicker, {
      [styles.error]: !!error,
   })

   return (
      <>
         {withWrappers ? (
            <FieldWrapper
               description={description}
               insetDescription={insetDescription}
               disabled={disabled}
               error={error}
               id={id}
               label={label}
               required={required}
               noMargin={noMargin}
            >
               <div className={styles.wrapper}>
                  <Datepicker
                     className={classes}
                     maxDate={maxDate}
                     minDate={minDate}
                     name={id}
                     id={id}
                     onChange={handleDatepickerChange}
                     selected={selectedDate}
                     dateFormat="d MMM yyyy"
                     placeholderText={placeholder || ''}
                     disabled={disabled}
                     popperPlacement={popperPlacement}
                  />
                  <label htmlFor={id} className={styles.iconWrapper}>
                     <BsCalendar3 size={18} />
                  </label>
               </div>
            </FieldWrapper>
         ) : (
            <div className={styles.wrapper}>
               <Datepicker
                  className={classes}
                  maxDate={maxDate}
                  minDate={minDate}
                  name={id}
                  id={id}
                  onChange={handleDatepickerChange}
                  selected={selectedDate}
                  dateFormat="d MMM yyyy"
                  placeholderText={placeholder || ''}
                  disabled={disabled}
                  popperPlacement={popperPlacement}
               />
               <label htmlFor={id} className={styles.iconWrapper}>
                  <BsCalendar3 size={18} />
               </label>
            </div>
         )}
      </>
   )
}

export default DateInput
